
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/affiliate-disclosure",
      function () {
        return require("private-next-pages/about/affiliate-disclosure.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/affiliate-disclosure"])
      });
    }
  